/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
author: hungry_beagle (https://sketchfab.com/hungry_beagle)
license: CC-BY-4.0 (http://creativecommons.org/licenses/by/4.0/)
source: https://sketchfab.com/3d-models/classic-red-coffee-mug-c89fa8b5390145488a28c41ec54ccc8d
title: Classic Red Coffee Mug
*/

import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'

export function Model(props) {
  const { nodes, materials } = useGLTF('/models/classic_red_coffee_mug/scene.gltf')
  return (
    <group {...props} dispose={null}>
      <group rotation={[-Math.PI / 2, 0, 0]}>
        <group rotation={[Math.PI / 2, 0, 0]}>
          <group position={[0, 0, 290.72]} rotation={[-Math.PI / 2, 0, -1.75]} scale={100}>
            <mesh geometry={nodes.MeshMug_Red_0.geometry} material={materials.material} />
            <mesh geometry={nodes.MeshMug_White_Mug_0.geometry} material={materials.White_Mug} />
          </group>
        </group>
      </group>
    </group>
  )
}

useGLTF.preload('/models/classic_red_coffee_mug/scene.gltf')
